'use server';

import { login, logout } from '@/lib/session';

export async function handleLogin(formData: FormData) {
  return await login(formData);
}

export async function handleLogout() {
  await logout();
}
